import Vue from 'vue'
import Storage from 'vue-ls' // https://www.npmjs.com/package/vue-ls

const options = {
  namespace: 'vuejs__', // key prefix
  name: 'ls', // name deposit_variable Vue.[ls] or this.[$ls],
  storage: 'local' // storage name session, local, memory
}

Vue.use(Storage, options)

// const { ls } = Storage.useStorage(options)
// export default ls
